import type { ReactNode } from "react";
import { Box } from "../../Box/Box";
import { Message } from "../../Message/Message";
import { Text } from "../../Text/Text";

export const FileUploaderMessageType = {
  EMPTY_FILES_LIST: "EMPTY_FILES_LIST",
  FILES_ERRORS: "FILES_ERRORS",
  LIMIT_EXCEEDED: "LIMIT_EXCEEDED",
  WAIT_FOR_LOAD: "WAIT_FOR_LOAD",
  CUSTOM: "CUSTOM",
} as const;

const MESSAGE_TEXTS = {
  [FileUploaderMessageType.EMPTY_FILES_LIST]: "Добавьте хотя бы один файл.",
  [FileUploaderMessageType.FILES_ERRORS]:
    "Файл с ошибкой отправить не получится. Чтобы продолжить, удалите такой файл или добавьте заново — в правильном размере или формате.",
  [FileUploaderMessageType.LIMIT_EXCEEDED]:
    "Вы добавили больше файлов, чем можно. Чтобы продолжить, удалите лишние.",
  [FileUploaderMessageType.WAIT_FOR_LOAD]:
    "Дождитесь окончания загрузки или отмените ее, чтобы продолжить.",
} as Record<keyof typeof FileUploaderMessageType, string>;

export function FileUploaderMessage({
  formError,
  id,
}: {
  formError:
    | {
        type: keyof Omit<typeof FileUploaderMessageType, typeof FileUploaderMessageType.CUSTOM>;
      }
    | { type: typeof FileUploaderMessageType.CUSTOM; content: ReactNode };
  id: string;
}) {
  return (
    <Box
      mb="sp-16"
      maxWidth={[1, "fileUploaderMaxWidth"]}
      id={id}
      role="alert"
      aria-live="assertive"
    >
      <Message kind="error">
        <Text fontSize="fileUploaderMessageFontSize">
          {formError.type === FileUploaderMessageType.CUSTOM
            ? formError.content
            : MESSAGE_TEXTS[formError.type]}
        </Text>
      </Message>
    </Box>
  );
}
